import { routes } from 'router';

// Quick Quote Journey
export const routePageMapQuote = {
  [routes.personalDetails]: 'vodalend compare: quick quote: personal details',
  [routes.employmentDetails]: 'vodalend compare: quick quote: employment details',
  [routes.offers]: 'vodalend compare: quick quote: product select',
};

export const routeLinkMapQuote = {
  [routes.personalDetails]: 'vodalend compare: quick quote: personal details: back',
  [routes.employmentDetails]: 'vodalend compare: quick quote: employment details: back',
  [routes.offers]: 'vodalend compare: quick quote: product select: back',
};

export const routeServiceNameMapQuote = {
  [routes.personalDetails]: 'vodalend compare: landing page: quick quote: personal details',
  [routes.employmentDetails]: 'vodalend compare: landing page: quick quote: employment details',
  [routes.offers]: 'vodalend compare: quick quote: product select',
};
